import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { widgetDataSelector } from 'app/store/selectors/dashboards';
import { widgetLoadingIdSelector } from 'app/store/selectors/widgets';
import WidgetContainer from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/WidgetContainer/WidgetContainer';
import EpisodeCostCard from './EpisodeCostCard/EpisodeCostCard';
const CostsWidget = ({ allEpisodes, displayedEpisodes, widget, steps, activeEpisodesByWidget, setActiveEpisodesByWidget, }) => {
    const { projectId } = useParams();
    const widgetsData = useSelector(widgetDataSelector(widget.id));
    const widgetLoadingId = useSelector(widgetLoadingIdSelector);
    const isLoading = widgetLoadingId === widget.id;
    const noSteps = steps.length === 0;
    const noEpisodes = displayedEpisodes.length === 0;
    const sortedEpisodes = displayedEpisodes
        .map((episodeId) => {
        const episodeInst = allEpisodes.find((e) => e.id === episodeId);
        return episodeInst;
    })
        // @ts-expect-error
        .sort((a, b) => (a === null || a === void 0 ? void 0 : a.name) - (b === null || b === void 0 ? void 0 : b.name));
    return (_jsxs(WidgetContainer, { widget: widget, allEpisodes: allEpisodes, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget, displayActionButton: true, displayError: noSteps || noEpisodes, isLoading: isLoading, children: [noSteps || noEpisodes ? (_jsx("p", { style: { fontSize: '20px' }, children: `No ${noSteps && noEpisodes ? 'steps and episodes' : noSteps ? 'steps' : 'episodes'} were set` })) : null, !noSteps &&
                sortedEpisodes.map((episode) => {
                    if (!episode)
                        return;
                    const { id: episodeId, name: episodeName } = episode;
                    const episodeData = widgetsData === null || widgetsData === void 0 ? void 0 : widgetsData[`episode_${episodeId}`];
                    return (_jsx(EpisodeCostCard, { projectId: projectId, episodeId: episodeId, episodeName: episodeName, episodeData: episodeData }, episodeId));
                })] }));
};
export default CostsWidget;
